import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = ({ sectionTitle, title, description }) => {
  return (
    <section className="bg-gray-900 dark:bg-gray-950 text-white px-6 lg:px-14">
      <div className="container mx-auto py-12 text-center md:text-left md:flex md:items-center md:justify-between">
        <div className="md:w-2/3">
          {sectionTitle && (
            <h6 className="text-xl font-bold mb-4">{sectionTitle}</h6>
          )}
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          <p className="text-lg md:text-xl mb-8 md:mb-0">{description}</p>
        </div>

        <div className="md:w-1/3 md:flex md:justify-end mt-4 md:mt-0">
          <Link
            to="/contact"
            className="inline-block bg-white dark:text-white dark:bg-blue-600 text-blue-500 py-3 px-8 rounded-lg shadow-lg font-semibold text-lg hover:scale-105 hover:bg-blue-500 hover:text-white transition duration-300"
          >
            Get Started
          </Link>
        </div>
      </div>
      <div className="border-t border-gray-300 dark:border-gray-800"></div>
    </section>
  );
};

export default CallToAction;
